const storage = localStorage;

const getToken = () => storage.getItem('jwt');
const setToken = (jwt: string) => storage.setItem('jwt', jwt);
const removeToken = () => storage.removeItem('jwt');

const getRToken = () => storage.getItem('rejwt');
const setRToken = (jwt: string) => storage.setItem('rejwt', jwt);
const removeRToken = () => storage.removeItem('rejwt');

const getUserId = () => storage.getItem('id');

const getRole = () => storage.getItem('role');
const setRole = (role: string) => storage.setItem('role', role);
const removeRole = () => storage.removeItem('role');

const savePair = (pair: any) => storage.setItem('pair', JSON.stringify(pair));
const getPair = () =>
  storage.getItem('pair')
    ? JSON.parse(storage.getItem('pair') as string)
    : {
        challenge: '',
        verifier: ''
      };

export {
  getToken,
  setToken,
  removeToken,
  savePair,
  getPair,
  getRToken,
  setRToken,
  removeRToken,
  getRole,
  setRole,
  removeRole,
  getUserId
};
